export const hasStoreUpcomingVacation = (vacationStart, vacationEnd) => {
    if (vacationStart === null || vacationEnd === null) {
        return false;
    }

    vacationEnd.setHours(23, 59, 59);

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return today <= vacationEnd;
}

export const hasStoreActiveVacation = (vacationStart, vacationEnd) => {
    if (!hasStoreUpcomingVacation(vacationStart, vacationEnd)) {
        return false;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return today >= vacationStart;
}

export const toShortFormatedDate = (date) => {
    return date.getDate() + '.' + (date.getMonth() + 1);
}
